import { render, staticRenderFns } from "./ViewCallbackYoutube.vue?vue&type=template&id=33a03300&scoped=true&"
import script from "./ViewCallbackYoutube.vue?vue&type=script&lang=ts&"
export * from "./ViewCallbackYoutube.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCallbackYoutube.vue?vue&type=style&index=0&id=33a03300&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a03300",
  null
  
)

export default component.exports